import { api } from "../base";
import type { IFixAuditMessageList } from "@pulse-ui/codegen-v2/generated_ts/fix_audit";

export type {
  IFixAuditMessage,
  IFixAuditMessageList,
} from "@pulse-ui/codegen-v2/generated_ts/fix_audit";

export interface GetFixAuditMessagesParams {
  sender_comp_id: string;
  target_comp_id: string;
  session_id?: string;
  direction?: string;
  msg_type?: string;
  from_ms?: number;
  to_ms?: number;
  limit?: number;
  token?: string;
}

const fixAuditMessagesEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getFixAuditMessages: build.query<
      IFixAuditMessageList,
      GetFixAuditMessagesParams
    >({
      query: (params) => ({
        url: "/api/trade/v1/fix-audit-messages",
        params,
      }),
      // "Load all" fetches many distinct pages; don't retain each in cache.
      keepUnusedDataFor: 0,
      providesTags: ["FixAuditMessages"],
    }),
  }),
});

export const {
  useGetFixAuditMessagesQuery,
  useLazyGetFixAuditMessagesQuery,
} = fixAuditMessagesEndpoints;
